let injected = false;

// Hub Culture brand defaults (overridable via the --hublogin-* custom properties)
const CSS = `
.hublogin-overlay {
  position: fixed;
  inset: 0;
  background: rgba(11, 25, 48, .6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2147483000;
  opacity: 0;
  visibility: hidden;
  transition: opacity .15s ease;
  --hublogin-primary: #16407C;
  --hublogin-primary-hover: #0f2f5e;
  --hublogin-accent: #60BF93;
}
.hublogin-overlay.is-open { opacity: 1; visibility: visible; }
.hublogin-card {
  position: relative;
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 380px;
  padding: 32px 28px 28px;
  box-shadow: 0 24px 70px rgba(11, 25, 48, .35);
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif;
  transform: translateY(8px);
  transition: transform .15s ease;
  box-sizing: border-box;
  text-align: center;
}
.hublogin-overlay.is-open .hublogin-card { transform: translateY(0); }
.hublogin-logo { height: 56px; width: auto; margin: 0 auto 14px; display: block; }
.hublogin-title { font-size: 20px; font-weight: 700; color: #16407C; margin: 0 0 4px; }
.hublogin-subtitle { font-size: 13px; color: #64748b; margin: 0 0 22px; }
.hublogin-close {
  position: absolute;
  top: 14px;
  right: 16px;
  background: none;
  border: none;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
  color: #94a3b8;
  padding: 4px;
}
.hublogin-close:hover { color: #16407C; }
.hublogin-field { margin-bottom: 14px; text-align: left; }
.hublogin-label { display: block; font-size: 13px; font-weight: 500; color: #334155; margin-bottom: 6px; }
.hublogin-input {
  width: 100%;
  box-sizing: border-box;
  padding: 11px 13px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
}
.hublogin-input:focus {
  outline: none;
  border-color: var(--hublogin-primary);
  box-shadow: 0 0 0 3px rgba(22, 64, 124, .18);
}
.hublogin-error { color: #dc2626; font-size: 13px; margin: 0 0 14px; min-height: 16px; text-align: left; }
.hublogin-error a { color: #dc2626; font-weight: 700; }

/* two-step visibility: the card carries data-step="1" | "2" */
.hublogin-card[data-step="1"] .hublogin-only-2,
.hublogin-card[data-step="2"] .hublogin-only-1 { display: none !important; }

.hublogin-label-row { display: flex; align-items: baseline; justify-content: space-between; }
.hublogin-pass-toggle {
  background: none; border: none; padding: 0 0 6px; cursor: pointer;
  font: inherit; font-size: 12.5px; font-weight: 600; color: var(--hublogin-primary);
}
.hublogin-identity {
  display: flex; align-items: center; justify-content: space-between; gap: 10px;
  background: #f1f5f9; border-radius: 8px; padding: 10px 12px; margin-bottom: 14px;
  text-align: left;
}
.hublogin-identity-email { font-size: 13.5px; color: #334155; overflow-wrap: anywhere; }
.hublogin-edit-email {
  background: none; border: none; padding: 0; cursor: pointer; white-space: nowrap;
  font: inherit; font-size: 12.5px; font-weight: 700; color: var(--hublogin-primary);
}
.hublogin-remember {
  display: flex; align-items: center; gap: 8px; margin: 0 0 14px;
  font-size: 13px; color: #334155; text-align: left; cursor: pointer;
}
.hublogin-remember input { margin: 0; }
.hublogin-submit {
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 999px;
  background: var(--hublogin-primary);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: .3px;
  cursor: pointer;
  transition: background .2s ease;
}
.hublogin-submit:hover { background: var(--hublogin-primary-hover); }
.hublogin-submit:disabled { opacity: .6; cursor: default; }
.hublogin-footer { margin-top: 18px; font-size: 12.5px; color: #64748b; line-height: 1.5; }
.hublogin-footer a { color: var(--hublogin-accent); font-weight: 600; text-decoration: none; }
.hublogin-footer a:hover { text-decoration: underline; }
`;

export function injectStyles() {
  if (injected) return;
  injected = true;
  const style = document.createElement('style');
  style.setAttribute('data-hub-login-styles', '');
  style.textContent = CSS;
  document.head.appendChild(style);
}
